import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = {
  class: "flex flex-row border-l-4 mr-2 mb-2 font-bold",
  style: {"border-color":"'#7fd6ff'"}
}
const _hoisted_4 = { class: "w-full py-2 px-4 flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-40 flex items-center text-lg" }, "決議地點", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex flex-row border-l-4 mr-2 mb-2 font-bold",
    style: {"border-color":"'#7fd6ff'"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-48 py-2 px-4 flex flex-row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "w-40 flex items-center text-lg" }, "決議時間")
    ])
  ])
], -1)
const _hoisted_7 = { class: "absolute z-10 text-black p-2" }
const _hoisted_8 = { class: "font-black" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 已回覆 ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", { class: "font-bold text-base" }, "以上皆非", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 已回覆 ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", { class: "font-bold text-base" }, "以上皆非", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" X " + /*#__PURE__*/_toDisplayString(0))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_MdRemove = _resolveComponent("MdRemove")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_MdPerson = _resolveComponent("MdPerson")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_n_radio = _resolveComponent("n-radio")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_radio_group = _resolveComponent("n-radio-group")!
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_n_input, {
            placeholder: "請輸入地點",
            value: _ctx.resolution.Location,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.resolution.Location) = $event))
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _hoisted_6,
    _createVNode(_component_n_scrollbar, { style: {"max-height":"200px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_n_radio_group, {
          value: _ctx.resolution.FianlSchedularId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resolution.FianlSchedularId) = $event)),
          name: "radiogroup",
          size: "large",
          "on-update:value": _ctx.makedicision
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_space, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userResponseSummary, (schedular) => {
                  return (_openBlock(), _createBlock(_component_n_popover, {
                    key: schedular.EventScheduleId,
                    trigger: "hover"
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_n_radio, {
                        value: schedular.EventScheduleId
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("b", _hoisted_8, _toDisplayString(_ctx.dateDisplay(schedular.ScheduleStartUTCDateTime)), 1),
                            _createTextVNode("   " + _toDisplayString(_ctx.startTimeDisplay(schedular.ScheduleStartUTCDateTime)) + " ", 1),
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_MdRemove)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.endTimeDisplay(schedular.ScheduleEndUTCDateTime)), 1)
                          ]),
                          _createVNode(_component_n_progress, {
                            type: "line",
                            percentage: 
                  _ctx.percentage(schedular.AgreeCount, _ctx.event?.HeadCount ?? 1)
                ,
                            height: 36,
                            "border-radius": 4,
                            "fill-border-radius": 0,
                            color: 
                  _ctx.changeColor(
                    _ctx.resolution.FianlSchedularId == schedular.EventScheduleId
                      ? _ctx.themeVars.successColor
                      : _ctx.themeVars.scrollbarColor,
                    { alpha: 0.2 }
                  )
                ,
                            class: "w-64"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_n_icon, { class: "text-xl" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_MdPerson)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" X " + _toDisplayString(schedular.AgreeCount), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["percentage", "color"])
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]),
                    default: _withCtx(() => [
                      (_ctx.eventResponseFilter(schedular?.EventScheduleId ?? '') !='')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            (_ctx.eventResponseFilter(schedular?.EventScheduleId ?? '') !='')
                              ? (_openBlock(), _createBlock(_component_n_tag, {
                                  key: 0,
                                  type: "warning"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.eventResponseFilter(schedular?.EventScheduleId ?? '')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "on-update:value"]),
        _createElementVNode("div", null, [
          _createVNode(_component_n_space, { class: "w-40 font-bold px-2 mt-6 rounded bg-buttonColor2Pressed cursor-pointer" }, {
            default: _withCtx(() => [
              (_ctx.personNone.count > 0)
                ? (_openBlock(), _createBlock(_component_n_popover, {
                    key: 0,
                    trigger: "hover"
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_n_space, { class: "pt-1" }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createVNode(_component_n_icon, { class: "text-xl" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MdPerson)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" X " + _toDisplayString(_ctx.personNone.count), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_n_tag, { type: "warning" }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.personNone.name), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_n_space, {
                    key: 1,
                    class: "pt-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createVNode(_component_n_icon, { class: "text-xl" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MdPerson)
                        ]),
                        _: 1
                      }),
                      _hoisted_14
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}